import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';
import { isSameDay, getDefaultScheduledDate } from '../../../../utils/dateFormatters-campaign.utils';
import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

export const ScheduleSection = ({
  scheduleType,
  sendType,
  scheduledDateTime,
  currentDateTime,
  onChange
}) => {

  const [pickerValue, setPickerValue] = useState(scheduledDateTime ?? null);

  useEffect(() => {
    setPickerValue(scheduledDateTime ?? null);
  }, [scheduledDateTime]);

  const handleScheduleTypeChange = (event) => {
    onChange({
      scheduleType: event.target.value,
    });
  };

  const handleSendTypeChange = (event) => {
    const nextSendType = event.target.value;

    onChange({
      sendType: nextSendType,
      scheduledDateTime:
        nextSendType === 'programar' && !scheduledDateTime
          ? getDefaultScheduledDate()
          : nextSendType === 'enviar_ahora'
          ? null
          : scheduledDateTime,
    });
  };


  const handleDateTimeChange = (newValue) => {
    setPickerValue(newValue);
    onChange({
      scheduledDateTime: newValue,
      sendType: 'programar',
    });
  };

  
 // * Validar si una fecha es válida según reglas que establecí
  const shouldDisableDate = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dateToCheck = new Date(date);
    dateToCheck.setHours(0, 0, 0, 0);

    return dateToCheck < today;
  };

  const isSelectedDateToday = useMemo(() => {
    if (!pickerValue) return false;
    return isSameDay(new Date(pickerValue), new Date());
  }, [pickerValue]);

  const minTimeForPicker = useMemo(() => {
    return isSelectedDateToday ? new Date() : undefined;
  }, [isSelectedDateToday]);


  return (
    <Box sx={{ mb: 3 }}>
      <FormControl component="fieldset" fullWidth sx={{ mb: 3 }}>
        <RadioGroup
          aria-label="cuando-enviar"
          name="cuando-enviar"
          value={sendType}
          onChange={handleSendTypeChange}
          row
        >
          <FormControlLabel value="enviar_ahora" control={<Radio />} label="Enviar ahora" />
          <FormControlLabel
            value="programar"
            control={<Radio />}
            label="Programar envío de campaña"
          />
        </RadioGroup>

        <Box sx={{ mt: 2 }}>
          {sendType === 'enviar_ahora' ? (
            <Typography variant="body2" color="text.secondary">
              Se enviará inmediatamente.
            </Typography>
          ) : sendType === 'programar' ? (
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
              <DateTimePicker
                size="small"
                label="Fecha y hora de envío"
                value={pickerValue}
                onChange={handleDateTimeChange}
                shouldDisableDate={shouldDisableDate}
                minDate={new Date()}
                minTime={minTimeForPicker}
                disableIgnoringDatePartForTimeValidation
                ampm={false}
                format="dd/MM/yyyy - HH:mm"
                slotProps={{
                  textField: {
                    fullWidth: false,
                    required: true,
                    helperText: 'Seleccione fecha y hora de envío',
                    sx: { width: '50%' },
                  },
                }}
              />
            </LocalizationProvider>
          ) : (
            <Typography variant="body2" color="text.secondary">
              Seleccione cuándo desea enviar la campaña
            </Typography>
          )}
        </Box>
      </FormControl>
    </Box>
  );
};

ScheduleSection.propTypes = {
  scheduleType: PropTypes.oneOf(['mismo_tiempo', 'por_partes']),
  sendType: PropTypes.oneOf(['enviar_ahora', 'programar', '']),
  scheduledDateTime: PropTypes.instanceOf(Date),
  currentDateTime: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
};
